export default "__VITE_ASSET__CyQLiFt3__"